import { Controller } from "@hotwired/stimulus"

// Handles bulk selection and actions for fixes
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "selectedCount", "bulkButton", "container"]

  connect() {
    this.updateCount()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateCount()
  }

  updateCount() {
    const selected = this.selectedCheckboxes
    const count = selected.length
    
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = `${count} selected`
    }
    
    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length
      this.selectAllTarget.checked = count === total && count > 0
      this.selectAllTarget.indeterminate = count > 0 && count < total
    }
    
    // Enable/disable bulk action buttons
    if (this.hasBulkButtonTarget) {
      this.bulkButtonTargets.forEach(button => {
        button.disabled = count === 0
      })
    }
  }

  async bulkApprove(event) {
    event.preventDefault()
    await this.performBulkAction("approve")
  }

  async bulkReject(event) {
    event.preventDefault()
    await this.performBulkAction("reject")
  }

  async bulkDelete(event) {
    event.preventDefault()
    if (!confirm("Are you sure you want to delete the selected fixes?")) {
      return
    }
    await this.performBulkAction("delete")
  }

  async performBulkAction(action) {
    const fixIds = this.selectedCheckboxes.map(cb => cb.dataset.fixId)

    console.log("[fix-bulk] performBulkAction:", action, "fixIds:", fixIds)

    if (fixIds.length === 0) {
      alert("No fixes selected")
      return
    }

    try {
      // Extract route params from URL
      const pathParts = window.location.pathname.split("/")
      const teamId = pathParts[1]
      const projectId = pathParts[3]
      const crawlId = pathParts[5]
      const auditId = pathParts[7]

      const url = `/${teamId}/projects/${projectId}/crawls/${crawlId}/site_audits/${auditId}/fixes/bulk_update`

      console.log("[fix-bulk] POSTing to:", url)

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({
          fix_ids: fixIds,
          bulk_action: action
        })
      })

      console.log("[fix-bulk] Response status:", response.status)

      if (response.ok) {
        const data = await response.json()
        console.log("[fix-bulk] Response data:", data)
        // Reload page to show updated state
        window.location.reload()
      } else {
        const errorText = await response.text()
        console.error("[fix-bulk] Error response:", errorText)
        alert(`Failed to ${action} fixes. Please try again.`)
      }
    } catch (error) {
      console.error("[fix-bulk] Bulk action error:", error)
      alert("An error occurred. Please try again.")
    }
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }
}

